(function () {
	'use strict';

	angular.module('dcApp').service('AppSelectorService', AppSelectorService);

	AppSelectorService.$inject = [
		'$q',
		'$window',
		'$rootScope',
		'NgCore',
		'LoggerFactory',
		'ProjectStorage',
		'STORAGE_SUFFIX',
		'JOBS_CACHE_STATUS',
	];

	function AppSelectorService(
		$q,
		$window,
		$rootScope,
		NgCore,
		LoggerFactory,
		ProjectStorage,
		STORAGE_SUFFIX,
		JOBS_CACHE_STATUS
	) {
		const logger = LoggerFactory.getLogger('AppSelectorService', false);
		let selectedProjectId = null;
		let selectedProjectLabel = null;
		let selectedProjectVersion = null;
		let selectedProjectVersionIsDefault = null;
		let projectVersionsCount = 0;
		let selectedCtx = null;
		let isJobsCacheActive = null;

		clearProjectSelection();

		this.setSelectedProject = setSelectedProject;
		this.setSelectedContext = setSelectedContext;
		this.setIsJobsCacheActive = setIsJobsCacheActive;
		this.clearProjectSelection = clearProjectSelection;
		this.getSelectedProjectId = getSelectedProjectId;
		this.getSelectedProjectLabel = getSelectedProjectLabel;
		this.getSelectedProjectVersion = getSelectedProjectVersion;
		this.getSelectedProjectVersionIsDefault =
			getSelectedProjectVersionIsDefault;
		this.getProjectVersionsCount = getProjectVersionsCount;
		this.getSelectedCtxId = getSelectedCtxId;
		this.getIsJobsCacheActive = getIsJobsCacheActive;

		function getSelectedProjectId() {
			if (selectedProjectId === null || selectedProjectId === undefined) {
				logger.warn(
					'no version project id available. Getting stored project id'
				);
				return ProjectStorage.getProjectId();
			}

			return selectedProjectId;
		}

		function getSelectedProjectLabel() {
			if (isEmpty(selectedProjectLabel)) {
				logger.warn(
					'no project label is available. Getting stored  project label'
				);
				return ProjectStorage.getProjectLabel();
			}

			return selectedProjectLabel;
		}

		function getSelectedProjectVersion() {
			return selectedProjectVersion;
		}

		function getSelectedProjectVersionIsDefault() {
			return selectedProjectVersionIsDefault;
		}

		function getProjectVersionsCount() {
			return projectVersionsCount;
		}

		function getSelectedCtxId() {
			if (selectedCtx === null) {
				logger.warn('no context is available. Getting stored context');
				return ProjectStorage.getSelectedContext();
			}
			return selectedCtx;
		}

		function setSelectedContext(ctxId) {
			selectedCtx = ctxId;
			logger.warn('setting context:', selectedCtx);
			ProjectStorage.setCurrentContext(ctxId);
		}

		function getIsJobsCacheActive() {
			if (isJobsCacheActive === null) {
				logger.warn('no value set by user. re');
			}
			return isJobsCacheActive;
		}

		function setIsJobsCacheActive(isActive) {
			isJobsCacheActive = isActive;
			logger.warn('setting jobs active state:', isJobsCacheActive);
			ProjectStorage.setIsJobsCacheActive(isActive);
		}

		function setSelectedProject(
			projectId,
			projectLabel,
			projectVersion,
			isDefaultVersion,
			versionCount
		) {
			selectedProjectId = projectId;
			selectedProjectLabel = projectLabel;
			selectedProjectVersion = projectVersion;
			selectedProjectVersionIsDefault = isDefaultVersion;
			projectVersionsCount = versionCount;

			ProjectStorage.setValue({
				projectId: parseInt(`${projectId}`, 10),
				projectLabel: projectLabel,
				projectVersion: projectVersion,
				isDefaultVersion: isDefaultVersion,
				versionCount: versionCount,
			});
			$rootScope.currentProject = projectLabel;
			$rootScope.currentProjectId = projectId;
			$rootScope.currentProjectVersion = projectVersion;
			$rootScope.currentProjectVersionIsDefault = isDefaultVersion;
			clearElementsListConf();
			$rootScope.$broadcast('update:project:selection');
			NgCore.setProject(parseInt(`${projectId}`, 10), projectLabel);
			return $q.resolve();
		}

		function clearProjectSelection() {
			$window.sessionStorage.removeItem(JOBS_CACHE_STATUS);
			$window.localStorage.removeItem(JOBS_CACHE_STATUS);
			clearElementsListConf();
		}

		/**
		 * Private functions
		 */

		function clearElementsListConf() {
			let filterKeys = _.filter(_.keys($window.localStorage), function (key) {
				return key.endsWith(STORAGE_SUFFIX);
			});
			_.each(filterKeys, function (key) {
				$window.localStorage.removeItem(key);
			});
		}
	}
})();
